export class LevelGroupLoader {
  constructor() {
    /** @private */
    this._loadingId = null;
  }

  loadLevels() {
    this._loadingId = Symbol('loading id');
  }
}
